// FIX: Replaced placeholder content with a functional ReportUserModal component.
import React, { useState } from 'react';
import { UserProfile } from '../types';

interface ReportUserModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (reason: string, details: string) => void;
    userToReport: UserProfile;
    triggerRect: DOMRect | null;
}

const ReportUserModal: React.FC<ReportUserModalProps> = ({ isOpen, onClose, onSubmit, userToReport }) => {
    const [reason, setReason] = useState('');
    const [details, setDetails] = useState('');
    
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (reason) {
            onSubmit(reason, details);
            onClose();
        }
    };
    
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-white p-4 rounded-lg shadow-xl w-full max-w-sm" onClick={e => e.stopPropagation()}>
                <h2 className="text-xl font-bold mb-4 text-gray-800">Report {userToReport.displayName}</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                     <div>
                        <label htmlFor="reason" className="block text-sm font-medium text-gray-700">Reason for reporting</label>
                        <select id="reason" value={reason} onChange={e => setReason(e.target.value)} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm rounded-md text-gray-800" required>
                            <option value="">Select a reason</option>
                            <option value="spam">Spam or scams</option>
                            <option value="impersonation">Impersonation</option>
                            <option value="harassment">Harassment or hate speech</option>
                            <option value="inappropriate_content">Inappropriate profile content</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="details" className="block text-sm font-medium text-gray-700">Additional Details (Optional)</label>
                        <textarea id="details" value={details} onChange={e => setDetails(e.target.value)} rows={3} className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-gray-800" placeholder="Provide more context here."></textarea>
                    </div>
                     <div className="flex justify-end gap-2">
                        <button type="button" onClick={onClose} className="bg-gray-200 text-gray-800 font-bold py-2 px-4 rounded-lg">Cancel</button>
                        <button type="submit" className="bg-red-600 text-white font-bold py-2 px-4 rounded-lg disabled:bg-gray-400" disabled={!reason}>Submit Report</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReportUserModal;